module.exports = __webpack_public_path__ + "img/c00_buildingtechpriceadjusting_Normal_ua.0842c587.webp";